import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { AuthService } from '../../service/authService.service';
import { I18nService } from '../../service/i18n.service';

@Component({
  selector: 'app-cabecalho',
  standalone: true,
  imports: [CommonModule, TranslateModule, MenubarModule, RouterModule],
  templateUrl: './cabecalho.component.html',
  styleUrl: './cabecalho.component.scss',
})
export class CabecalhoComponent implements OnInit {
  translate = inject(TranslateService);
  i18nService = inject(I18nService);

  items: MenuItem[] | undefined;
  logado = signal(false);
  authService = inject(AuthService);
  isScrolled = signal(false);

  constructor() {
    this.translate.use(this.i18nService.idioma.value.code);
  }

  ngOnInit() {
    this.items = [
      {
        label: 'CABECALHO_PORTAL.INICIO',
        command: () => this.scrollToSection('home')
      },
      {
        label: 'CABECALHO_PORTAL.SOBRE',
        command: () => this.scrollToSection('about')
      },
      {
        label: 'CABECALHO_PORTAL.SOLUCOES',
        command: () => this.scrollToSection('products')
      },
      {
        label: 'Equipe',
        command: () => this.scrollToSection('team')
      },
      {
        label: 'Cases',
        command: () => this.scrollToSection('cases')
      },
      {
        label: 'CABECALHO_PORTAL.CONTATO',
        command: () => this.navigateToWhatsApp()
      },
    ];

    this.authService.validateToken().subscribe({
      next: (token: boolean) => {
        this.logado.set(token);
      },
      error: () => {
        this.logado.set(false);
      },
    });

    // Scroll effect
    window.addEventListener('scroll', () => {
      this.isScrolled.set(window.scrollY > 100);
    });
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  navigateToWhatsApp(): void {
    const whatsappUrl = "https://api.whatsapp.com/send/?phone=553199179151&text=Ol%C3%A1%21+Visitei+seu+site+e+gostaria+de+conhecer+seus+servi%C3%A7os&type=phone_number&app_absent=0";
    window.open(whatsappUrl, '_blank');
  }
}
